import ProductsAd from "../ProductsAd";

const ProductsHeroAd = () => (
  <div className="container my-xl min-h-[186px] md:min-h-[208px] lg:min-h-[278px] flex items-center">
    <ProductsAd unit="category_hero" className="w-full" />
  </div>
);

export default ProductsHeroAd;
